// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
// $FlowFixMe
import MuiFormControl from '@material-ui/core/FormControl';
// $FlowFixMe
import MuiFormLabel from '@material-ui/core/FormLabel';
// $FlowFixMe
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import { colors, fontWeight } from 'seedling/constants';

type Props = {
  className?: string,
  name: string,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => mixed,
  children: Node,
  value: string | number | boolean,
  title?: string,
};

const RadioGroupHeading = styled.div`
  font-family: 'Untitled Sans', sans-serif;
  ${fontWeight('normal')};
  font-size: 12px;
  color: ${colors.darkGrey};
  margin-bottom: 2px;
`;

const RadioGroupContainer = styled.div`
  margin: 14px 0;
`;

function RadioGroup(props: Props) {
  return (
    <MuiFormControl component="fieldset">
      {props.title && (
        <MuiFormLabel component="legend">
          <RadioGroupHeading>{props.title}</RadioGroupHeading>
        </MuiFormLabel>
      )}
      <RadioGroupContainer>
        <MuiRadioGroup
          aria-label={props.name}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
        >
          {props.children}
        </MuiRadioGroup>
      </RadioGroupContainer>
    </MuiFormControl>
  );
}

export default RadioGroup;
